var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 7.57598L5 3",
    stroke: "#2D3B87",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.4426V6.33151C16.9997 6.01975 16.9174 5.71356 16.7614 5.44365C16.6054 5.17375 16.3811 4.94961 16.1111 4.79373L9.88889 1.23818C9.61863 1.08214 9.31206 1 9 1C8.68793 1 8.38137 1.08214 8.11111 1.23818L1.88889 4.79373C1.6189 4.94961 1.39465 5.17375 1.23863 5.44365C1.08262 5.71356 1.00032 6.01975 1 6.33151V13.4426C1.00032 13.7544 1.08262 14.0606 1.23863 14.3305C1.39465 14.6004 1.6189 14.8245 1.88889 14.9804L8.11111 18.536C8.38137 18.692 8.68793 18.7741 9 18.7741C9.31206 18.7741 9.61863 18.692 9.88889 18.536L16.1111 14.9804C16.3811 14.8245 16.6054 14.6004 16.7614 14.3305C16.9174 14.0606 16.9997 13.7544 17 13.4426Z",
    stroke: "#2D3B87",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.5L9.00024 9.89611L16.5 5.5",
    stroke: "#2D3B87",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99951 18L8.99951 9.88867",
    stroke: "#2D3B87",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.3bc36894071043b8ac065bddcf01991f.svg";
export { ForwardRef as ReactComponent };